import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';

import {
  CREDIT_CONSENT_COPY,
  CREDIT_TERMS_URL,
  LOAN_CONSENT_COPY,
  LOAN_TERMS_URL,
} from 'src/app/constants/consent.constant';

/**
 * I have reviewed and agree with the following:
 *
 * Contains the following {FormControl}s:
 * * Over18
 * * PrivacyPolicy
 * * CommunicationConsent
 */
@Component({
  selector: 'app-agreement-info',
  templateUrl: './agreement-info.component.html',
  styleUrls: ['./agreement-info.component.scss'],
})
export class AgreementInfoComponent implements OnInit {
  @Input() controls: {
    [key: string]: AbstractControl;
  } = {};

  @Input() isConsumerLoanApplication = true;

  loanConsentCopy = LOAN_CONSENT_COPY;
  creditConsentCopy = CREDIT_CONSENT_COPY;
  loanTermsURL = LOAN_TERMS_URL;
  creditTermsURL = CREDIT_TERMS_URL;

  constructor() {}

  ngOnInit(): void {}

  getFormControl(key: string): FormControl {
    return this.controls[key] as FormControl;
  }
}
